//General purpose fetch  
const feline_fetch = async ({ url, full_url, method, headers, body, is_form_data, credentials }) => {
	try {
		if (full_url) {
			url = full_url;
		} else {
			url = global.config.server_path + url;
		}
		if (!url) {
			throw 'invalid url provided';
		}
		if(!method) {
			method = 'POST';
		}
		if (!is_form_data) {
			if (!headers) {
				headers = {
					'Content-Type': 'application/json'
				};
			}
			if (body) {
				body = JSON.stringify(body);
			}
		}
		if (!credentials) {
			credentials = 'include';
		}

        var options = { method, headers, credentials, body };
        var resp = await fetch(url, options);
        resp = await resp.json();
        if (resp.response_code == 1) {
        	return resp.data;
        } else {
        	throw new Error('Server call failed with error --' + resp.error); 
        }
	} catch(err) {
		return Promise.reject({ err, info: 'Error in feline_fetch' })
	}
} 

export default { 
	feline_fetch 
};